import { clientLogos } from "./clientLogos";

const INTERNATIONAL_LOCATION_PATTERNS = [
  { pattern: /Egypt/i, country: "Egypt" },
  { pattern: /Kenya/i, country: "Kenya" },
  { pattern: /Rwanda/i, country: "Rwanda" },
];

function countDeploymentCountries(clients) {
  const countries = new Set(["India"]);

  for (const client of clients) {
    for (const { pattern, country } of INTERNATIONAL_LOCATION_PATTERNS) {
      if (pattern.test(client.location)) {
        countries.add(country);
      }
    }
  }

  return countries.size;
}

const hospitalsDeployed = clientLogos.length;
const countriesCovered = countDeploymentCountries(clientLogos);

export const deploymentSiteCount = hospitalsDeployed;
export const deploymentCountryCount = countriesCovered;

const coreDeploymentMetrics = [
  {
    value: `${hospitalsDeployed}+`,
    target: hospitalsDeployed,
    valueFormat: "plus",
    label: "Hospitals Deployed",
    sub: "Production-ready rollouts",
  },
  {
    value: `${countriesCovered}+`,
    target: countriesCovered,
    valueFormat: "plus",
    label: "Countries Covered",
    sub: "Global footprint",
  },
];

/** Hidden until accurate figures are available. */
export const deferredDeploymentMetrics = [
  {
    value: "1M+",
    target: 1,
    valueFormat: "millions",
    label: "Patients Managed Every Year",
    sub: "Across deployments",
  },
  {
    value: "1 Cr+",
    target: 1,
    valueFormat: "crores",
    label: "Transactions Processed",
    sub: "Billing & clinical volume",
  },
];

const operationalEfficiencyMetric = {
  value: "30%",
  target: 30,
  valueFormat: "percent",
  label: "Average Improvement in Operational Efficiency",
  sub: "Reported by partner sites",
};

/** Impact row shown in Social Proof (resources). */
export const deploymentImpactStats = [
  ...coreDeploymentMetrics,
  operationalEfficiencyMetric,
];
